import { addToBasket } from "src/features/product-modal/productModalApi";
const isMobileApp = Boolean(window?.ReactNativeWebView);

export default async function requestAddToBasket(productPk: string) {
  const basketData = {
    product: productPk,
    quantity: 1,
  };

  // signal React Native App
  if (isMobileApp) {
    window?.ReactNativeWebView?.postMessage(
      JSON.stringify({
        type: "addToBasket",
        payload: basketData,
      })
    );

    return;
  }
  await addToBasket(basketData);
}
